import { IPropertiesOfPatchChangesForModifier } from 'types';

export const properties: IPropertiesOfPatchChangesForModifier[] = [
	{ id: 'price', name: 'price' },
	{ id: 'supplementPrice', name: 'supplementPrice' },
	{ id: 'quantityMaxLimit', name: 'quantityMaxLimit' },
	{ id: 'activation', name: 'activation' },
	{ id: 'deactivation', name: 'deactivation' },
	{ id: 'isDisabled', name: 'isDisabled' },
	{ id: 'isRestricted', name: 'isRestricted' },
	{ id: 'isPreselected', name: 'isPreselected' },
	{ id: 'forceDisable', name: 'forceDisable' },
];
